<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-tabs value="second" @tab-click="handleClick">
        <el-tab-pane label="网络媒体" name="first"></el-tab-pane>
        <el-tab-pane label="自媒体" name="second"></el-tab-pane>
      </el-tabs>
      <div class="media-cell">
        所属平台：
        <el-radio v-model="menhu" label="不限">不限</el-radio>
        <el-radio v-model="menhu" label="网易">今日头条</el-radio>
        <el-radio v-model="menhu" label="腾讯">百家号</el-radio>
        <el-radio v-model="menhu" label="今日头条">今日头条</el-radio>
      </div>
      <div class="media-cell">
        行业类型：
        <el-radio v-model="pindao" label="不限">不限</el-radio>
        <el-radio v-model="pindao" label="文化">文化</el-radio>
        <el-radio v-model="pindao" label="历史">历史</el-radio>
        <el-radio v-model="pindao" label="三农">三农</el-radio>
      </div>
      <div class="media-cell">
        参考粉丝量：
        <el-radio v-model="quyu" label="不限">不限</el-radio>
        <el-radio v-model="quyu" label="1万以下">1万以下</el-radio>
        <el-radio v-model="quyu" label="1万-5万">1万-5万</el-radio>
        <el-radio v-model="quyu" label="5万-10万">5万-10万</el-radio>
      </div>
      <div class="media-cell">
        参考阅读量：
        <el-radio v-model="shoulu" label="不限">不限</el-radio>
        <el-radio v-model="shoulu" label="1000以下">1000以下</el-radio>
        <el-radio v-model="shoulu" label="1000-5000">1000-5000</el-radio>
        <el-radio v-model="shoulu" label="5000-1万">5000-1万</el-radio>
      </div>
      <div class="media-cell">
        价格区间：
        <el-radio v-model="jiage" label="0">不限</el-radio>
        <el-radio v-model="jiage" label="1">0-20</el-radio>
        <el-radio v-model="jiage" label="2">21-50</el-radio>
        <el-radio v-model="jiage" label="3">51-75</el-radio>
        <el-radio v-model="jiage" label="4">76-100</el-radio>
        <el-radio v-model="jiage" label="5">100以上</el-radio>
      </div>
      <div class="media-cell" style="height:60px;  line-height: 50px;">
        媒体名称：
        <div class="media-input">
          <el-input v-model="sousuo" placeholder="请输入媒体编号或名称"></el-input>
        </div>
        <p class="media-p1">可发内链</p>
        <div class="media-select">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <p class="media-p2">可发联系方式</p>
        <div class="media-select2">
          <el-select v-model="value2" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="media-p3">
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="button" @click="resh">重置</el-button>
        </div>
      </div>
      <el-table :data="tableData" highlight-current-row style="width:100%" v-loading="loading">
        <el-table-column property="name" label="媒体名称"></el-table-column>
        <el-table-column property="price" label="价格"></el-table-column>
        <el-table-column property="portal" label="平台"></el-table-column>
        <el-table-column property="channel" label="行业"></el-table-column>
        <el-table-column property="linkable" label="是否带链接"></el-table-column>
        <el-table-column property="contactable" label="带联系方式"></el-table-column>
        <el-table-column property="rate" label="出稿率"></el-table-column>
        <el-table-column property="speed" label="出稿速度"></el-table-column>
        <el-table-column property="area" label="参考粉丝量"></el-table-column>
        <el-table-column property="included" label="参考阅读量"></el-table-column>
        <el-table-column property="auth" label="是否认证"></el-table-column>
        <el-table-column property="remark" label="备注"></el-table-column>
      </el-table>
      <div class="Pagination" style="text-align: left;margin-top: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="index"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="count"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import myAxios from "../myAxios";
import HeadTop from "../components/HeadTop";

export default {
  data() {
    return {
      activeName: "second",
      url: localStorage.getItem("url"),
      tableData: [], //用户列表数据
      index: 1, //页码
      size: 20, //页大小
      count: 0, //数据总数
      loading: false, //加载状态
      menhu: "不限",
      pindao: "不限",
      quyu: "不限",
      shoulu: "不限",
      jiage: "0",
      sousuo: "", //媒体名称
      options: [
        //可发内链
        {
          //选择器1
          value: "请选择",
          label: ""
        },
        {
          value: "是",
          label: "是"
        },
        {
          value: "否",
          label: "否"
        }
      ],
      value: "", //选择器1
      options2: [
        //可发联系方式
        {
          //选择器2
          value: "请选择",
          label: ""
        },
        {
          value: "是",
          label: "是"
        },
        {
          value: "否",
          label: "否"
        }
      ],
      value2: "" //选择器2
    };
  },
  components: {
    HeadTop
  },
  created() {
    this.initData();
  },
  methods: {
    // 搜索
    search() {
      console.log(
        this.menhu + this.pindao + this.quyu + this.shoulu + this.jiage
      );
      console.log(this.sousuo);
      console.log(this.value + this.value2);
      myAxios
        .get(
          `/client_user/MediaList/v1?selfMedia=true&portal=${
            this.menhu
          }&channel=${this.pindao}&area=${this.quyu}&included=${
            this.shoulu
          }&priceRange=${this.jiage}&name=${this.sousuo}&linkable=${
            this.value
          }&contactable=${this.value2}`
        )
        .then(res => {
          this.tableData = res.data;
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].auth) {
              this.tableData[i].auth = "是";
            } else {
              this.tableData[i].auth = "否";
            }
            if (this.tableData[i].contactable) {
              this.tableData[i].contactable = "是";
            } else {
              this.tableData[i].contactable = "否";
            }
            if (this.tableData[i].linkable) {
              this.tableData[i].linkable = "是";
            } else {
              this.tableData[i].linkable = "否";
            }
          }
          this.count = res.total;
        });
    },
    async initData() {
      try {
        this.getUsers();
      } catch (err) {
        console.log("获取数据失败");
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.index = val;
      this.getUsers();
    },
    resh() {
      this.$router.go(0);
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.getUsers();
    },
    async getUsers() {
      myAxios.get(`/client_user/MediaList/v1?selfMedia=true`).then(res => {
        this.tableData = res.data;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].auth) {
            this.tableData[i].auth = "是";
          } else {
            this.tableData[i].auth = "否";
          }
          if (this.tableData[i].contactable) {
            this.tableData[i].contactable = "是";
          } else {
            this.tableData[i].contactable = "否";
          }
          if (this.tableData[i].linkable) {
            this.tableData[i].linkable = "是";
          } else {
            this.tableData[i].linkable = "否";
          }
        }
        console.log(this.tableData);
        this.count = res.total;
      });
      this.loading = false;
    },
    handleClick(tab, event) {
      console.log(tab.index);
      if (tab.index == 1) {
      } else {
        this.$router.push({ path: "/mediaList" });
      }
    }
  }
};
</script>

<style lang="less">
@import "../style/mixin";
.table_container {
  padding: 20px;
}
.media-cell {
  position: relative;
  height: 30px;
  border-bottom-color: #eeeeee;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  margin-top: 10px;
}
.media-input {
  width: 200px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 8%;
}
.media-p1 {
  position: absolute;
  top: 0;
  left: 28%;
}
.media-select {
  position: absolute;
  top: 0;
  left: 35%;
}
.media-p2 {
  position: absolute;
  top: 0;
  left: 55%;
}
.media-p3 {
  position: absolute;
  top: 0;
  left: 85%;
}
.media-select2 {
  position: absolute;
  top: 0;
  left: 65%;
}
</style>